import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  public encryptSecretIndex: number = 4;

  constructor() { }

  encryptData(data) {
    if (data == null || data == undefined)
      return data;

    try {
      var result = data;
      for (var i = 0; i < this.encryptSecretIndex; i++) {
        result = window.btoa(result).toString();
      }
      return result;
    } catch (e) {
      console.error(e);
      return data;
    }
  }

  decryptData(data) {
    if (data == null || data == undefined)
      return data;

    try {
      var result = data;
      for (var i = 0; i < this.encryptSecretIndex; i++) {
        result = window.atob(result).toString();
      }
      return result;
    } catch (e) {
      console.error(e);
      return data;
    }
  }


}
